<template>
  <div :style="boxStyle">
    <span :style="{ fontSize: big ? '44px' : '18px', fontWeight: 800, color: 'rgba(255,255,255,.92)', letterSpacing: '.02em' }">
      {{ monogram(title) }}
    </span>
  </div>
</template>

<script setup>
// A record with no image: its monogram on a deterministic accent gradient.
// Ported from collection-frame Media. `h` is a fixed pixel height; `ratio` an
// aspect-ratio string (e.g. "4 / 3").
import { computed } from 'vue'
import { accentFor, monogram } from '@/admin-collection-layout/lib/collectionHelpers.js'

const props = defineProps({
  record: { type: Object, required: true },
  config: { type: Object, required: true },
  h: { type: Number, default: null },
  ratio: { type: String, default: null },
})

const title = computed(() => props.config.primary(props.record))
const accent = computed(() => (props.config.accent ? props.config.accent(props.record) : accentFor(title.value)))
const big = computed(() => props.ratio || (props.h && props.h > 90))
const boxStyle = computed(() => ({
  ...(props.ratio ? { aspectRatio: props.ratio, width: '100%' } : { height: `${props.h}px` }),
  borderRadius: '10px',
  background: `linear-gradient(135deg, ${accent.value}, color-mix(in srgb, ${accent.value} 55%, #000))`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}))
</script>
